import { apiSlice } from './apiSlice';
const EXPENSES_URL = '/api/expenses';

export const expensesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExpenses: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: EXPENSES_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Expenses'],
    }),
    getExpenseDetails: builder.query({
      query: (expenseId) => ({
        url: `${EXPENSES_URL}/${expenseId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    createExpense: builder.mutation({
      query: (expenseData) => ({
        url: EXPENSES_URL,
        method: 'POST',
        body: expenseData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Expenses'],
    }),
    updateExpense: builder.mutation({
      query: ({ expenseId, ...data }) => ({
        url: `${EXPENSES_URL}/${expenseId}`,
        method: 'PUT',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Expenses'],
    }),
    uploadExpenseImages: builder.mutation({
      query: (formData) => ({
        url: '/api/upload',
        method: 'POST',
        body: formData,
      }),
    }),
    bulkUpdateExpenses: builder.mutation({
  query: (expenseData) => ({
    url: `${EXPENSES_URL}/bulk`, // Adjust this if your backend uses a different route
    method: 'PUT',
    body: expenseData,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  invalidatesTags: ['Expenses'],
}),
    deleteExpense: builder.mutation({
      query: (expenseId) => ({
        url: `${EXPENSES_URL}/${expenseId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Expenses'],
    }),
    createReview: builder.mutation({
      query: ({ expenseId, ...data }) => ({
        url: `${EXPENSES_URL}/${expenseId}/reviews`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Expenses'],
    }),
    getTopExpenses: builder.query({
      query: () => `${EXPENSES_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});


export const {
  useGetExpensesQuery,
  useGetExpenseDetailsQuery,
  useCreateExpenseMutation,
  useUpdateExpenseMutation,
  useUploadExpenseImagesMutation,
  useDeleteExpenseMutation,
  useCreateReviewMutation,
  useGetTopExpensesQuery,
  useBulkUpdateExpensesMutation,
} = expensesApiSlice;